<template>
<div class="rhesis">
  <!-- 输入框 -->
  <el-input v-model="title" placeholder="题目" style="width:15%"></el-input>
  <el-input v-model="author" placeholder="作者" style="width:15%"></el-input>
  <el-button type="primary" @click="handleSearch">搜索</el-button>
  <el-divider></el-divider>
  <!-- rhesis内容 -->
  <el-table
    :data="tableData"
    style="width: 100%"
    stripe
    v-loading.fullscreen.lock="fullscreenLoading"
  >
  <!-- el-table 内可以用如下的属性来控制显示的样式 :row-class-name="tableRowClassName" -->
    <el-table-column prop="title" label="题目" width="320"> </el-table-column>
    <el-table-column prop="author" label="作者" width="120"> </el-table-column>
    <el-table-column prop="content" label="句子" width="auto"> </el-table-column>
  </el-table>
  <el-divider></el-divider>
  <!-- 分页码器 -->
  <el-pagination
    background
    layout="prev, pager, next"
    :total="total"
    class="pagination"
    @current-change="changePage"
  >
  </el-pagination>
</div>
</template>

<script>
import axios from 'axios'
import surl from '@/common'
export default {
  name: 'Rhesis',
  methods: {
    handleRhesis (res) {
      var dt = res.data.data
      console.log(dt)
      this.tableData = dt.rhesis
      this.page = dt.page
      this.perPage = dt.per_page || 10
      this.total = dt.total
      this.fullscreenLoading = false
    },
    changePage (pageNum) {
      this.fullscreenLoading = true
      if (this.author === '' && this.title === '') {
        var url = surl.PROD_URL + '/v1/rhesis?page=' + pageNum
      } else {
        url = surl.PROD_URL + '/v1/rhesis?page=' + pageNum + '&filter_by=author:$like:' + this.author + '|title:$like:' + this.title
        console.log(url)
      }
      axios.get(url)
        .then(this.handleRhesis)
    },
    handleSearch () {
      this.fullscreenLoading = true
      if (this.author === '' && this.title === '') {
        this.$confirm('请输入有效的诗词名字或者作者')
      } else {
        let url = surl.PROD_URL + '/v1/rhesis?filter_by=author:$like:' + this.author + '|title:$like:' + this.title
        console.log(url)
        axios.get(url)
          .then(this.handleRhesis)
      }
    }
  },
  data () {
    return {
      fullscreenLoading: true,
      tableData: [],
      page: 0,
      perPage: 10,
      total: 10,
      title: '',
      author: '',
      content: ''
    }
  },
  mounted: function () {
    axios.get(surl.PROD_URL + '/v1/rhesis')
      .then(this.handleRhesis)
  }
}
</script>

<style>
  .rhesis {
    width: -moz-fit-content;
    width: -webkit-fit-content;
    width: 70%;
    margin: 30px auto;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .pagination {
    width: -moz-fit-content;
    width: -webkit-fit-content;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Rhesis/Rhesis.vue